import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { getFleetOperationalReportByAsset, getFleetOperationalReportByGroup } from '../../../services/fleetService';
import { apiParamsState } from '../../../storage/app';
import {
  fleetOperationalReportIsUpdatingState,
  fleetReportEndDateState,
  fleetReportSearchTypeState,
  fleetReportSelectedAssetIdState,
  fleetReportSelectedGroupIdState,
  fleetReportStartDateState,
  updateOperationalReportsState,
} from '../../../storage/fleetReports';

export function useFleetOperational() {
  const apiParams = useRecoilValue(apiParamsState);
  const startDate = useRecoilValue(fleetReportStartDateState);
  const endDate = useRecoilValue(fleetReportEndDateState);
  const selectedGroupId = useRecoilValue(fleetReportSelectedGroupIdState);
  const searchType = useRecoilValue(fleetReportSearchTypeState);
  const selectedAssetId = useRecoilValue(fleetReportSelectedAssetIdState);
  const resetStartDate = useResetRecoilState(fleetReportStartDateState);
  const resetEndDate = useResetRecoilState(fleetReportEndDateState);
  const resetSelectedGroupId = useResetRecoilState(fleetReportSelectedGroupIdState);
  const resetSearchType = useResetRecoilState(fleetReportSearchTypeState);
  const resetSelectedAssetId = useResetRecoilState(fleetReportSelectedAssetIdState);
  const [reload, setReload] = useRecoilState(updateOperationalReportsState);
  const isUpdating = useRecoilValue(fleetOperationalReportIsUpdatingState);

  const resetFilters = () => {
    resetStartDate();
    resetEndDate();
    resetSelectedGroupId();
    resetSearchType();
    resetSelectedAssetId();
  };

  const onReload = () => {
    setReload('update');
  };

  const onUpdated = () => {
    setReload(undefined);
  };

  const loadFleetOperationalByAsset = async () => {
    if (!apiParams)
      return {
        data: undefined,
        error: 'Selecciona un espacio de trabajo.',
      };
    if (!startDate || !endDate || !selectedAssetId) return { data: undefined };
    const { data, error } = await getFleetOperationalReportByAsset({
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      assetId: selectedAssetId,
      startDate,
      endDate,
    });
    return {
      data,
      error,
    };
  };

  const loadFleetOperationalByGroup = async () => {
    if (!apiParams)
      return {
        data: undefined,
        error: 'Selecciona un espacio de trabajo.',
      };
    if (!startDate || !endDate || !selectedGroupId) return { data: undefined };
    const { data, error } = await getFleetOperationalReportByGroup({
      clientId: apiParams.clientId,
      subClientId: apiParams.subClientId,
      groupId: selectedGroupId,
      startDate,
      endDate,
    });
    return {
      data,
      error,
    };
  };

  return {
    isUpdating,
    loadFleetOperationalByAsset,
    loadFleetOperationalByGroup,
    onReload,
    reload,
    resetFilters,
    onUpdated,
    filters: {
      startDate,
      endDate,
      selectedGroupId,
      searchType,
      selectedAssetId,
    },
  };
}
